var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChecked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#D2CCDE",
    cx: 25,
    cy: 25,
    r: 25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5 40.61c8.828 0 15.984-7.157 15.984-15.985S34.328 8.641 25.5 8.641 9.516 15.797 9.516 24.625 16.672 40.609 25.5 40.609zm0-3.094c-7.124 0-12.89-5.766-12.89-12.891 0-7.124 5.765-12.89 12.89-12.89 7.124 0 12.89 5.765 12.89 12.89 0 7.124-5.765 12.89-12.89 12.89zm-2.092-5.257 11.124-11.035c.303-.3.305-.79.005-1.093l-1.453-1.465a.773.773 0 0 0-1.094-.004l-9.11 9.037-3.854-3.885a.773.773 0 0 0-1.094-.004l-1.464 1.452a.774.774 0 0 0-.005 1.094l5.852 5.899c.3.303.79.305 1.093.004z",
    stroke: "#D2CCDE",
    strokeWidth: 0.5,
    fill: "#5E3EA1",
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.3e4603ed4da996e158ef9b7be6340e9e.svg";
export { ForwardRef as ReactComponent };